<div class="preview">
  <div class="preview__head">
    <span class="preview__title">Fee preview</span>
  </div>

  @if (loading && !rows.length) {
    <p class="preview__state">Loading sample products…</p>
  } @else if (unavailable) {
    <p class="preview__state preview__state--unavailable">Can't load preview. Shopify didn't respond.</p>
  } @else if (!rows.length) {
    <p class="preview__state">Add a rule to see what a sample cart would be charged.</p>
  } @else {
    <div class="preview__rows" [class.is-refreshing]="loading">
      @for (row of rows; track row.key) {
        <div class="preview__row" [class.is-unmatched]="!row.matched">
          <div class="preview__label">
            <span class="preview__title-line">
              <strong>{{ row.label }}</strong>
              @if (row.ruleLabel) {
                <span class="preview__rule-chip">{{ row.ruleLabel }}</span>
              }
            </span>
            <small>
              {{ row.matchedRuleLabel }}
              @if (row.rateLabel) {
                ({{ row.rateLabel }})
              } @else if (row.unmatchedFeeCents) {
                ({{ row.unmatchedFeeCents / 100 | currency: currency : 'symbol' }} per item)
              } @else if (row.unmatchedPercent) {
                ({{ row.unmatchedPercent }}% of item price)
              }
            </small>
            @if (row.shadowedByLabel) {
              <small class="preview__excluded"
                >This rule never charges it — "{{ row.shadowedByLabel }}" matches first</small
              >
            }
            @if (row.excludedUnits) {
              <small class="preview__excluded">{{ excludedLabel(row) }}</small>
            }
          </div>

          @if (row.matched) {
            <pdq-input-arrows
              [dirty]="true"
              class="preview__stepper"
              min="0"
              precision="0"
              width="60"
              widthSize="auto"
              aria-label="Quantity"
              [ngModel]="row.quantity"
              [ngModelOptions]="{ standalone: true }"
              (ngModelChange)="setQuantity(row.lineId, $event)"></pdq-input-arrows>
          }
          @if (row.feeCents !== undefined) {
            <span class="preview__amount">{{ row.feeCents / 100 | currency: currency : 'symbol' }}</span>
          }
        </div>
      }
    </div>

    @if (charges.length) {
      <div class="preview__charges">
        @for (charge of charges; track charge.key) {
          <div class="preview__charge">
            <span class="preview__charge-label">
              <strong>{{ charge.label }}</strong>
              <small>
                {{ charge.detail }}
                @if (charge.excludedFeeCents) {
                  (&minus;{{ charge.excludedFeeCents / 100 | currency: currency : 'symbol' }})
                }
              </small>
            </span>
            <span class="preview__amount">{{ charge.feeCents / 100 | currency: currency : 'symbol' }}</span>
          </div>
        }
      </div>
    }

    <div class="preview__totals">
      <div>
        <span>Item fees</span><span>+{{ itemFeesCents / 100 | currency: currency : 'symbol' }}</span>
      </div>
      @if (baseRateKnown) {
        <div>
          <span>Base shipping method rate</span><span>{{ baseRateCents / 100 | currency: currency : 'symbol' }}</span>
        </div>
        <div class="preview__total">
          <span>Shipping charged</span><span>{{ totalCents / 100 | currency: currency : 'symbol' }}</span>
        </div>
      } @else {
        <div class="preview__note">
          <span>Added to this method's base rate, which is set elsewhere.</span>
        </div>
      }
    </div>
  }
</div>
